export default "__VITE_ASSET__B_kH0PGH__"